(() => {
  if (customElements.get("product-selector")) {
    return;
  }

  class ProductSelector extends HTMLElement {
    constructor() {
      super();
      this.variants = JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      );
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.form = document.querySelector(`form#${this.dataset.form}`);
      this.form.addEventListener("submit", () => {
        setTimeout(() => {
          this.isVariantAdded();
          this.updateForm();
        }, 3000)
      })
      this.addEventListener("change", this.onVariantChange.bind(this));
    }

    /**
     * On variant change.
     *
     * @param {Event} event
     */
    onVariantChange(event) {
      this.updateOptions();
      this.updateVariant();
      this.isVariantAdded();
    }

    isVariantAdded() {
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const variantIds = cart.items.map(item => item.variant_id);
          this.setAttribute('data-included', variantIds.includes(this.currentVariant.id));
          this.updateForm();
        })
        .catch((error) => console.error('Error fetching cart:', error));
    }

    /**
     * Update options.
     */
    updateOptions() {
      this.options = Array.from(
        this.querySelectorAll('input[type="radio"]:checked'),
        (el) => ({
          name: el.name,
          value: el.value,
        })
      );
    }

    /**
     * Update variant.
     */
    updateVariant() {
      this.currentVariant = this.variants.find((variant) => {
        return !variant.options
          .map((option, index) => this.options[index]?.value === option)
          .includes(false);
      });
      this.setAttribute('data-variant-id', this.currentVariant.id);
    }

    updateForm() {
      this.form.elements["id"].value = this.currentVariant.id;
      this.form.querySelector('button[type="submit"]').setAttribute('data-button-content',
        this.getAttribute('data-included') === 'true' ? window.themeVariables.strings.productFormAddedInCart : window.themeVariables.strings.productFormAddToCart
      )
      this.form.dispatchEvent(
        new CustomEvent("variant:changed", {
          detail: {
            variant: this.currentVariant,
          },
          bubbles: true,
        })
      );
    }
  }

  customElements.define("product-selector", ProductSelector);
})();
